import { render } from "./HospitalBrandingPanel.vue?vue&type=template&id=a7891ef4&scoped=true"
import script from "./HospitalBrandingPanel.vue?vue&type=script&lang=js"
export * from "./HospitalBrandingPanel.vue?vue&type=script&lang=js"

import "./HospitalBrandingPanel.vue?vue&type=style&index=0&id=a7891ef4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7891ef4"]])

export default __exports__